
import { QuestionBase, QuestionBaseParams, QuestionUITypes } from './question-base';
import { FormControl, FormGroup, Validators, ValidatorFn, AsyncValidator, AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export class TextboxQuestion extends QuestionBase<string> {
  public questionType: QuestionUITypes = QuestionUITypes.STRING;

  constructor(questionParams: QuestionBaseParams<string>) {
    super(questionParams);
  }

  public getValidators() : Array<ValidatorFn> {
    let validators = super.getValidators();
    switch( this.key ){
      case 'geburtsdatum':
        //Because we use special bootstrap date picker
        //validators.push( ( control: AbstractControl ) => { return this.dateValid( control ) } );
      break;
    }

    return validators;
  }

  public dateValid(control: AbstractControl): ValidationErrors | null{
    if( !control.value.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/) ){
      return { 'error' : 'Date should be formatted like 1.1.1970' };
    }

    var possibleDate = moment( control.value, 'DD.MM.YYYY' );
    if( possibleDate.isValid() ){
      return null;
    }else{
      return { 'error' : 'Date should be formatted like 1.1.1970' };
    }
  }

  public getValidatorsAsync() : Array<AsyncValidatorFn> {
    return [];
  }

  public getValueForRequest() : string{
    return this.getAvailableValue();
  }
}


// WEBPACK FOOTER //
// ./src/app/question-textbox.ts